import React from 'react';
import Input from 'antd/lib/checkbox';
var INPUT_STYLE = {
  width: '100%'
};
var ColorWidget = function ColorWidget(_ref) {
  var disabled = _ref.disabled,
    formContext = _ref.formContext,
    id = _ref.id,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    placeholder = _ref.placeholder,
    readonly = _ref.readonly,
    value = _ref.value;
  var _formContext$readonly = formContext.readonlyAsDisabled,
    readonlyAsDisabled = _formContext$readonly === void 0 ? true : _formContext$readonly;
  var handleChange = function handleChange(_ref2) {
    var target = _ref2.target;
    return onChange(target.value);
  };
  var handleBlur = function handleBlur(_ref3) {
    var target = _ref3.target;
    return onBlur(id, target.value);
  };
  var handleFocus = function handleFocus(_ref4) {
    var target = _ref4.target;
    return onFocus(id, target.value);
  };
  return /*#__PURE__*/React.createElement(Input, {
    disabled: disabled || readonlyAsDisabled && readonly,
    id: id,
    name: id,
    onBlur: !readonly ? handleBlur : undefined,
    onChange: !readonly ? handleChange : undefined,
    onFocus: !readonly ? handleFocus : undefined,
    placeholder: placeholder,
    style: INPUT_STYLE,
    type: "color",
    value: value
  });
};
export default ColorWidget;